export enum PieceCode {
  WHITE_PAWN = "wP",
  BLACK_PAWN = "bP",
  WHITE_KNIGHT = "wN",
  BLACK_KNIGHT = "bN",
  WHITE_BISHOP = "wB",
  BLACK_BISHOP = "bB",
  WHITE_ROOK = "wR",
  BLACK_ROOK = "bR",
  WHITE_QUEEN = "wQ",
  BLACK_QUEEN = "bQ",
  WHITE_KING = "wK",
  BLACK_KING = "bK",
}
